import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';

export default class TelemetrySearchService extends BaseService {
  constructor() {
    super(constants.GET_TELEMETRY_SEARCH_DATA, constants.TELEMETRY_SEARCH_STATUS);
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').post(constants.TELEMETRY_SEARCH_ENDPOINT, payload, {
        headers: enhancedHeaders
      });
    }
    return this.getClient('aiadmin').post(constants.TELEMETRY_SEARCH_ENDPOINT, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      Framework.getStoreRegistry().getStore('telemetrySearch').setResponse(response.data);
    }
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        Framework.getStoreRegistry().getStore('notificationState').set({
          open: true,
          message: data.error.message,
          type: 'error'
        });
      }
      if (status === 400 && data && data.message) {
        Framework.getStoreRegistry().getStore('notificationState').set({
          open: true,
          message: data.message,
          type: 'error'
        });
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      Framework.getStoreRegistry().getStore('notificationState').set({
        open: true,
        message: error.message,
        type: 'error'
      });
    }
    Framework.getStoreRegistry().getStore('telemetrySearch').resetStoreValues();
  }
}
